import type { ProductIntent } from "@/lib/products/types";

interface InventoryCreateUrlOptions {
  productSlug: string;
  intent: ProductIntent;
  quantity?: string;
  zip?: string;
  gradingSession?: string;
}

function appendInventoryCreateParams(
  params: URLSearchParams,
  options: InventoryCreateUrlOptions,
) {
  params.set("productSlug", options.productSlug);
  params.set("intent", options.intent);
  if (options.quantity) params.set("quantity", options.quantity);
  if (options.zip) params.set("zip", options.zip);
  if (options.gradingSession) {
    params.set("grading_session", options.gradingSession);
  }
}

export function buildInventoryCreateUrl(
  options: InventoryCreateUrlOptions,
): string {
  const params = new URLSearchParams();
  appendInventoryCreateParams(params, options);
  return `/dashboard/inventory/new?${params.toString()}`;
}

export function buildInventorySignUpUrl(
  options: InventoryCreateUrlOptions,
): string {
  const params = new URLSearchParams();
  params.set("intent", options.intent);
  params.set("returnTo", buildInventoryCreateUrl(options));
  return `/sign-up?${params.toString()}`;
}

export function buildInventorySignInUrl(
  options: InventoryCreateUrlOptions,
): string {
  const params = new URLSearchParams();
  params.set("intent", options.intent);
  params.set("returnTo", buildInventoryCreateUrl(options));
  return `/sign-in?${params.toString()}`;
}
